import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axiosInstance from '../Authservices/axiosInstance.js';
import './SigninForm.css';

const Signin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);
  const [userIdForReset, setUserIdForReset] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Check if an HR user is already logged in, redirect them to HR dashboard
    const storedRole = localStorage.getItem('role');
    if (storedRole && storedRole !== 'HR') {
      localStorage.clear(); // Clear storage if unauthorized user tries to access
      navigate('/signin'); // Redirect unauthorized users
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    setForgotPasswordVisible(false);

    if (!username || !password || !role) {
      setError('Please fill in all fields.');
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.post('user/signin', {
        username,
        password,
        role,
      });

      const { userId, name, token, refreshToken, role: userRole, department } = response.data;

      // Store data in localStorage
      localStorage.setItem('userId', userId);
      localStorage.setItem('name', name);
      localStorage.setItem('username', username);
      localStorage.setItem('accessToken', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('role', userRole);
      localStorage.setItem('department', department);

      // Check if the user is HR before allowing access
      if (userRole === 'HR') {
        navigate('/team-chart');
      } else {
        setError('Access Denied! Only HR users can sign in here.');
        localStorage.clear(); // Clear session storage if unauthorized
      }
    } catch (err) {
      console.error('Error during sign-in:', err);

      if (err.response) {
        setError(err.response.data.message || 'Invalid credentials');
        if (err.response.data.message === 'Incorrect password') {
          setForgotPasswordVisible(true);
          setUserIdForReset(err.response.data.userId);
        }
      } else if (err.request) {
        setError('No response from server. Please try again later.');
      } else {
        setError('Error: ' + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-image-wrapper">
        <img src="./logo-ems.jpg" alt="Authentication" className="auth-image" />
      </div>

      <form className="auth-form-container" onSubmit={handleSubmit}>
        <h2 className="auth-form-title">Sign In</h2>

        {loading && <p className="auth-loading">Loading...</p>}
        {error && <p className="auth-error" style={{ color: 'red' }}>{error}</p>}

        <div className="auth-input-group">
          <div className="fancy-select-wrapper">
            <select
              className="fancy-select"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
            >
              <option value="" disabled>Select your role</option>
              <option value="Admin">Admin</option>
              <option value="Employee">Employee</option>
              <option value="HR">HR</option>            </select>
          </div>
        </div>

        <div className="auth-input-group">
          <input
            className="auth-input"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter Username"
            required
          />
        </div>

        <div className="auth-input-group">
          <input
            className="auth-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="******"
            required
          />
        </div>

        <button className="auth-signin-button" type="submit" disabled={loading}>
          {loading ? 'Signing In...' : 'Sign In'}
        </button>

        <div
          className={`forgot-password-wrapper ${forgotPasswordVisible ? 'visible' : ''}`}
        >
          <p className="forgot-password-link">
            Forgot Password?{' '}
            <NavLink to={`/password-reset?userId=${userIdForReset}`}>
              Click Here!
            </NavLink>
          </p>
        </div>
      </form>
    </div>
  );
};

export default Signin;
